import { render, staticRenderFns } from "./producttradeAnalysis.vue?vue&type=template&id=3e4f0f6c&scoped=true&"
import script from "./producttradeAnalysis.vue?vue&type=script&lang=js&"
export * from "./producttradeAnalysis.vue?vue&type=script&lang=js&"
import style0 from "./producttradeAnalysis.vue?vue&type=style&index=0&id=3e4f0f6c&prod&lang=scss&"
import style1 from "./producttradeAnalysis.vue?vue&type=style&index=1&id=3e4f0f6c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e4f0f6c",
  null
  
)

export default component.exports